export const ALLERGENS = [
  { code: "glutine", label: "Glutine", short: "GLU" },
  { code: "crostacei", label: "Crostacei", short: "CRO" },
  { code: "uova", label: "Uova", short: "UOV" },
  { code: "pesce", label: "Pesce", short: "PES" },
  { code: "arachidi", label: "Arachidi", short: "ARA" },
  { code: "soia", label: "Soia", short: "SOI" },
  { code: "latte", label: "Latte e lattosio", short: "LAT" },
  { code: "frutta_a_guscio", label: "Frutta a guscio", short: "FRG" },
  { code: "sedano", label: "Sedano", short: "SED" },
  { code: "senape", label: "Senape", short: "SEN" },
  { code: "sesamo", label: "Sesamo", short: "SES" },
  { code: "solfiti", label: "Anidride solforosa e solfiti", short: "SOL" },
  { code: "lupini", label: "Lupini", short: "LUP" },
  { code: "molluschi", label: "Molluschi", short: "MOL" },
];

export const allergenLabel = (code) => ALLERGENS.find((a) => a.code === code)?.label || code;

export const DIET_TAGS = [
  { code: "vegetariano", label: "Vegetariano" },
  { code: "vegano", label: "Vegano" },
  { code: "senza_glutine", label: "Senza glutine" },
];
export const dietLabel = (code) => DIET_TAGS.find((t) => t.code === code)?.label || code;
